<template>
  <div>
    <b-modal
      id="modalInfo"
      v-model="isOpen"
      modal-class="modalInfo"
      :title="$t('label_evaluation_evidencesRequested_confirmation_title')"
    >
      <div style="color: red; padding: 20px">
        {{
          $t(
            "label_evaluation_requirementEvaluation_evidenceResubmission_warning"
          )
        }}
      </div>
      <div slot="modal-footer" class="w-100" style="text-align: center">
        <div class="d-flex justify-content-around">
          <b-row>
            <b-col>
              <b-btn @click="isOpen = false">
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_evidenceResubmission_warning_cancel"
                  )
                }}
              </b-btn>
            </b-col>
            <b-col>
              <b-btn variant="primary" @click="evidenceNoReady()">
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_evidenceResubmission_warning_send"
                  )
                }}
              </b-btn>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
//import { axiosCall } from "../utils/axiosCall";
import { mapGetters } from "vuex";
export default {
  name: "EvaluationEvidenceResubmissionModal",
  props: ["showModal", "requirement", "account", "evaluationId"],
  computed: {
    isOpen: {
      get() {
        return this.showModal;
      },
      set(newValue) {
        this.$emit("update:showModal", newValue);
      },
    },
    ...mapGetters(["getLang"]),
  },
  methods: {
    saveAndForce() {
      this.$emit("saveAndForce");
    },
    async evidenceNoReady() {
      // eslint-disable-next-line camelcase
      /*this.requirement.evaluation_administrator_node_editRequirement_evidencesReady =
                "label_evaluation_evidencesRequested_status_resubmit";*/
      let updateValues = {
        evaluation_administrator_node_editRequirement_evidencesReady:
          "label_evaluation_evidencesRequested_status_resubmit",
      };
      await this.$store.dispatch("updateEvaluation", {
        valuesToUpdate: updateValues,
      });
      /*await axiosCall({
                url:
                "Evaluations/envidencesReady/" + this.getLang + "/" + this.evaluationId + "/0",
                method: "POST",
                data: this.account,
            }).then(() => {});*/
      this.isOpen = false;
    },
  },
};
</script>

<style lang="sass" >

</style>
